import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Component from '../../lib/component'
gsap.registerPlugin(ScrollTrigger)

export default class VizBannerComponent extends Component {
    static selector () {
        return '.vizbanner'
    }

    constructor (opts) {
        super(opts)

        this.sections = document
            .querySelectorAll('section')

        this.cssShow = 'vizbanner-show'

        if (!this.sections)
            return

        this.render()
    }

    render () {
        ScrollTrigger.create({
            trigger: 'main',
            endTrigger: this.sections[2],
            end: 'top top', // second section leaves the viewport
            toggleClass: {
                targets: this.el,
                className: this.cssShow
            }
        })
    }
}
